/**
 * Choose "bookmark/layer" from (map.bookmarks.items) and zoom to it, get opacity 1.
 * not chosen "bookmark/layer" will be opacity 0.3
 *
 * @param {string} bookmarkNameOrId
 * @param {Object} map
 * @param {Object} view
 */
export async function selectLayer(bookmarkNameOrId, map, view) {
  if (!map || !view || !bookmarkNameOrId) {
    return;
  }

  const target = bookmarkNameOrId.toString().trim().toLowerCase();
  const bookmarksCollection = map.bookmarks && map.bookmarks.items ? map.bookmarks.items : null;
  if (!bookmarksCollection || bookmarksCollection.length === 0) {
    return;
  }

  const bookmark = bookmarksCollection.find((bm) => {
    if (!bm) {
      return false;
    }

    const name = (bm.name || bm.title || bm.label || '').toString().trim().toLowerCase();

    return name === target;
  });

  if (!bookmark) {
    return;
  }

  let targetExtent = null;
  if (bookmark.extent) {
    targetExtent = bookmark.extent;
  } else if (bookmark.viewpoint && bookmark.viewpoint.targetGeometry) {
    targetExtent = bookmark.viewpoint.targetGeometry;
  } else if (bookmark.viewpoint && bookmark.viewpoint.camera) {
    targetExtent = bookmark.viewpoint.camera;
  }

  try {
    if (targetExtent) {
      await view.goTo(targetExtent);
    } else {
      await bookmark.goTo(view);
    }
  } catch (error) {
    console.warn('Error while zoom to bookmark: ', error);
  }

  // switch layer opacity
  if (map.layers && typeof map.layers.forEach === 'function') {
    map.layers.forEach((layer) => {
      try {
        if (!layer || !layer.id) {
          /* eslint-disable no-param-reassign */
          layer.opacity = 0.3;

          return;
        }

        const layerIdNorm = layer.id.toString().trim().toLowerCase();
        if (layerIdNorm === target) {
          layer.opacity = 1;
        } else {
          layer.opacity = 0.2;
        }
      } catch (error) {
        console.warn(error);
      }
    });
  }
}

/**
 * Reset all layers back to opacity 1
 *
 * @param {Object} map
 */
export function resetLayerSelection(map) {
  if (!map || !map.layers || typeof map.layers.forEach !== 'function') {
    return;
  }

  /* eslint-disable no-param-reassign */
  map.layers.forEach((layer) => {
    try {
      layer.opacity = 1;
    } catch (error) {
      console.warn(error);
    }
  });
}
